const integerOrZero = (number) => {
  let mutatedNumber = parseInt(number);
  isNaN(mutatedNumber) && (mutatedNumber = 0);
  return mutatedNumber;
};

export default integerOrZero;
